<template>
  <div class="flex justify-start bottom-0 px-3 pb-5 pt-3" >
    <router-link to="/adoption"
      class="inline-flex items-center px-3 py-2 text-sm sm:text-md lg:text-lg font-medium text-center text-white bg-action rounded-lg shadow-lg hover:bg-navigation focus:ring-4 focus:outline-none focus:ring-navigation dark:action dark:hover:bg-navigation dark:focus:ring-navigation" aria-label="En savoir plus sur l'adoption !" title="En savoir plus sur l'adoption !">
      <font-awesome-icon icon="fa-solid fa-paw" class="text-lg sm:text-xl lg:text-2xl pr-3" />
      En savoir plus sur l'adoption !
    </router-link>
  </div>
</template>